import { render } from "./HistorialPagosConvenioPage.vue?vue&type=template&id=84096b44"
import script from "./HistorialPagosConvenioPage.vue?vue&type=script&lang=js"
export * from "./HistorialPagosConvenioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__